<div class="dialog-header">
	<div class="header-title">
		<span style="font-size: 120%;">Tasks
		</span>
	</div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="tasks-list">

	<ng-container *ngIf="tasksLoading">
		<lib-progress-spinner></lib-progress-spinner>
	</ng-container>

	<div class="tasks-container" *ngIf="!tasksLoading">
		<div class=" card-wrapper" *ngFor="let task of tasks" (click)="editTask(task)">
			<app-task-card [task]="task" [fromProj]="true" [showFrom]="true"></app-task-card>
		</div>
	</div>
</div>